/**
 * 공개 화면(FAQ·상품 상세·에디터)의 배송비 안내(SUPER-86 spec §6-1, 교차 조정 R9) — 금액은 적지 않는다. 공개 화면은 배송비 설정 응답을
 * 받지 않고, 고정 금액을 적으면 운영자가 설정을 바꿀 때 틀린다. 실제 금액은 견적 요청 화면의 임시 견적이 설정값으로 보여 준다.
 */

/** 예상 금액 아래 한 줄. */
export const SHIPPING_FEE_EXTRA_NOTE = '배송비 별도(배송지마다, 제주·도서산간 추가)';

/** 견적 가이드 FAQ '배송비와 배송기간' 답변. */
export const SHIPPING_FAQ_ANSWER =
  '배송비는 배송지마다 붙어요. 제주·도서산간은 추가 요금이 있고, 여러 곳으로 나눠 받을 수 있어요(최대 10곳). ' +
  '견적 요청 화면에서 배송지를 넣으면 배송비가 바로 계산돼요. 대량·화물 배송은 확정견적에서 조정해 드려요. ' +
  '배송기간은 출고 뒤 1~3일이에요(도서산간은 더 걸릴 수 있어요).';
